function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-666.000000, -298.000000)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, 95.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(540.000000, 150.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(123.000000, 50.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  transform: "translate(57.000000, 57.000000) rotate(-315.000000) translate(-57.000000, -57.000000) ",
  x: 17,
  y: 17,
  width: 80,
  height: 80,
  rx: 8
}))))));
var SvgIconDiamond = function SvgIconDiamond(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "108px",
    height: "108px",
    viewBox: "0 0 108 108",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconDiamond, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-diamond.fb5636c9.svg";
export { ForwardRef as ReactComponent };